import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import store from "Store/index";
import { UserHierarchyViewModel, GetCreateNewChildUserHierarchyListRequest, UserHierarchyClient} from 'Api/CoreApi';
import ApiFactory from 'Api/ApiFactory';
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import DOMHelper from "Helpers/DOMIsReady";
import Multiselect from 'vue-multiselect';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';



export interface SelectedSupportedLevelModel{
    id: string;
    name: string;
}

export interface SelectModel{
    id: string;
    name: string;
    obj: UserHierarchyViewModel;
    $isDisabled: boolean;
}

@Component({
    components: {
        Multiselect
    }
})
export default class OrderingListNewChildDebitorComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    
    supportedLevels: Array<any> = [];
    
    public selectedSupportedLevel: SelectedSupportedLevelModel = null;
    
    public list: { [key: string]: UserHierarchyViewModel[]; } = null
    public  selected: SelectModel = null;
    
    refToInputSelectedLevel: HTMLInputElement = null;

    refToInputCustomerNumber: HTMLInputElement = null;
    refToInputCustomerUsername: HTMLInputElement = null;
    
    
    async mounted(){
        
        if(!this.isAdvancedAdmin) return;
        
        //build selected supported levels - with translations
        this.supportedLevels[0] = <SelectedSupportedLevelModel> {
            id: 'AB',
            name: (unescape(document.getElementById('OrderingListCreateNewChildDebitorLevelAB').innerHTML))
        };
        //this.supportedLevels[1] = <SelectedSupportedLevelModel> {
        //    id: 'AC',
        //    name: (unescape(document.getElementById('OrderingListCreateNewChildDebitorLevelAC').innerHTML))
        //};
        this.supportedLevels[2] = <SelectedSupportedLevelModel> {
            id: 'BC',
            name: (unescape(document.getElementById('OrderingListCreateNewChildDebitorLevelBC').innerHTML))
        };
        
        console.debug('supported levels',this.supportedLevels);
        
        this.setLoading();
        const client = await ApiFactory.getOrderingListUserHierarchyClient();
        const response = await client.getCreateNewChildUserHierarchyList(new GetCreateNewChildUserHierarchyListRequest());
        this.list = response.list;
        this.setLoaded();
        

        DOMHelper.docReady(() => {
            this.refToInputSelectedLevel = <HTMLInputElement> this.$refs.selectedLevel;
            this.refToInputCustomerUsername = <HTMLInputElement> this.$refs.parentCustomerUserName;
            this.refToInputCustomerNumber = <HTMLInputElement> this.$refs.parentCustomerNumber;
    
        });
        
    }
    
    
    get userHierarchy(): { [key: string]: UserHierarchyViewModel[]; } {
        return this.list;
    }
    
    
    onSelect(model: SelectModel){
        this.selected = model;
        this.refToInputCustomerNumber.value = model.obj.customerNumber;
        this.refToInputCustomerUsername.value = model.obj.userIdentity;
    }
    
    customSupportedParentLevels(model: SelectedSupportedLevelModel){
        return model.name;
    }
    
    
    get supportedParentLevels(): SelectedSupportedLevelModel[]{
        return this.supportedLevels;
    }
    
    onSelectSupportedLevel(model: SelectedSupportedLevelModel){
        this.selectedSupportedLevel = model;
        this.refToInputSelectedLevel.value = model.id;
    }
    
    //selector
    get options(): any{
        if(this.userHierarchy && this.selectedSupportedLevel){
            {
                const list = new Array<SelectModel>();
                for(let key in this.userHierarchy)
                {
                    const value = this.userHierarchy[key];
                    
                    // const parentObj = value[0].parent;
                    
                    // if(parentObj){
                    //     list.push(<SelectModel>{
                    //         id : key,
                    //         $isDisabled: true,
                    //         name: key,
                    //         obj : parentObj
                    //     });
                    // }
                    
                    
                    for(let child of value)
                    {
                        
                        switch(this.selectedSupportedLevel.id){
                            case 'AB': 
                            {
                                if(child.level != 1) continue;
                                break;
                            }
                            case 'AC': 
                            {
                                if(child.level != 1) continue;
                                break;
                            }
                            case 'BC' : 
                            {
                                if(child.level != 2) continue;
                                break;
                            }
                        }
                        
                        
                        var obj: SelectModel = {
                            id : child.customerNumber,
                            $isDisabled : false,
                            name : child.customerNumber,
                            obj : child
                        }
                        list.push(obj);
                    }
                }
                return list;
            }
        }
        return new Array<SelectModel>();
    }
    
    customLabel(model: SelectModel): string{
        if(model == null) return '';
        if(model.$isDisabled){
            return `${model.obj.level} | ${this.customLabelForUser(model.obj)}`;
        }
        else{
            return `${model.obj.level} | ${this.customLabelForUser(model.obj)}`;
        }
    }
    
    
    customLabelForUser(obj: UserHierarchyViewModel): string {
        return `${obj.customerNumber.replace('-at-SHOP1','')} (${obj.companyName} : ${obj.customerAddress})`;
    }
    
}

Vue.component('ordering-list-new-child-debitor', OrderingListNewChildDebitorComponent);
